
import env from '@/config/env.js'
const bootenv = env()
let urlPath = {
  DEV: {
    loginPath:
      "https://home.test.yunshanmeicai.com/user/logout?system_key=sso",

    oasadminPath: "https://workflow.test.yunshanmeicai.com",
    tripPath: "https://trip.test.yunshanmeicai.com/#/mine/trip/list",
    mamsPath: "https://home.test.yunshanmeicai.com/mams/#/index",
    taskPath: "http://v4.21tb.test.com/os/html/task/todayTask.index.do?goV5Desk=true",
    subscribePath: "https://webs.yunshanmeicai.com/web/meeting/#/meeting-book",
    todoPath: "https://portal.test.yunshanmeicai.com/#/todo/list",
    retrievePath: "https://sso.test.yunshanmeicai.com/user/retrieve",
    helpPath: "https://help.test.yunshanmeicai.com",
    helpCreatePath: "https://help.test.yunshanmeicai.com/#/workticket/create?businessId=37",
    mamsPath: "http://home-test.yunshanmeicai.com/mams/#/index",
    homePath: "https://sso.test.yunshanmeicai.com/site/index?hometype=1",
    performancePath: "https://home.test.yunshanmeicai.com/sp-fe-user/",
    myPermission: "https://home.test.yunshanmeicai.com/permission/#/myPermission",
    managerView: "https://home.test.yunshanmeicai.com/manager-view/",
    kmsPath: "https://kms.test.yunshanmeicai.com/yunshanPublishHome/index.mc",
    workfacePath: "https://workface.test.yunshanmeicai.com"
  },
  TEST: {
    loginPath:
      "https://sso.test.yunshanmeicai.com/user/logout?system_key=sso",
    oasadminPath: "https://workflow.test.yunshanmeicai.com",
    tripPath: "https://trip.test.yunshanmeicai.com/#/mine/trip/list",
    mamsPath: "https://home.test.yunshanmeicai.com/mams/#/index",
    taskPath: "http://v4.21tb.test.com/os/html/task/todayTask.index.do?goV5Desk=true",
    subscribePath: "https://webs.yunshanmeicai.com/web/meeting/#/meeting-book",
    todoPath: "https://portal.test.yunshanmeicai.com/#/todo/list",
    retrievePath: "https://sso.test.yunshanmeicai.com/user/retrieve",
    helpPath: "https://help.test.yunshanmeicai.com",
    helpCreatePath: "https://help.test.yunshanmeicai.com/#/workticket/create?businessId=37",
    mamsPath: "http://home-test.yunshanmeicai.com/mams/#/index",
    homePath: "https://sso.test.yunshanmeicai.com/site/index?hometype=1",
    performancePath: "https://home.test.yunshanmeicai.com/sp-fe-user/",
    myPermission: "https://home.test.yunshanmeicai.com/permission/#/myPermission",
    managerView: "https://home.test.yunshanmeicai.com/manager-view/",
    kmsPath: "https://kms.test.yunshanmeicai.com/yunshanPublishHome/index.mc",
    workfacePath: "https://workface.test.yunshanmeicai.com"
  },
  TEST2: {
    loginPath: "https://sso.test2.yunshanmeicai.com/user/logout?system_key=sso",
    oasadminPath: "https://workflow.test2.yunshanmeicai.com",
    tripPath: "https://trip.test2.yunshanmeicai.com/#/mine/trip/list",
    mamsPath: "https://home.test2.yunshanmeicai.com/mams/#/index",
    taskPath: "http://v4.21tb.test2.com/os/html/task/todayTask.index.do?goV5Desk=true",
    subscribePath: "https://webs.yunshanmeicai.com/web/meeting/#/meeting-book",
    todoPath: "https://portal.test2.yunshanmeicai.com/#/todo/list",
    retrievePath: "https://sso.test2.yunshanmeicai.com/user/retrieve",
    helpPath: "https://help.test2.yunshanmeicai.com",
    helpCreatePath: "https://help.test2.yunshanmeicai.com/#/workticket/create?businessId=37",
    mamsPath: "http://home-test2.yunshanmeicai.com/mams/#/index",
    homePath: "https://sso.test2.yunshanmeicai.com/site/index?hometype=1",
    performancePath: "https://home.test2.yunshanmeicai.com/sp-fe-user/",
    myPermission: "https://home-test2.yunshanmeicai.com/permission/#/myPermission",
    kmsPath: "https://kms.test2.yunshanmeicai.com/yunshanPublishHome/index.mc",
    workfacePath: "https://workface.test2.yunshanmeicai.com"

  },
  STAGE: {
    loginPath: "https://sso.stage.yunshanmeicai.com/user/logout?system_key=sso",
    oasadminPath: "https://workflow.stage.yunshanmeicai.com",
    tripPath: "https://trip.stage.yunshanmeicai.com/#/mine/trip/list",
    mamsPath: "https://home.stage.yunshanmeicai.com/mams/#/index",
    taskPath: "http://v4.21tb.stage.com/os/html/task/todayTask.index.do?goV5Desk=true",
    subscribePath: "https://webs.yunshanmeicai.com/web/meeting/#/meeting-book",
    todoPath: "https://portal.stage.yunshanmeicai.com/#/todo/list",
    retrievePath: "https://sso.stage.yunshanmeicai.com/user/retrieve",
    helpPath: "https://help.stage.yunshanmeicai.com",
    helpCreatePath: "https://help.stage.yunshanmeicai.com/#/workticket/create?businessId=37",
    mamsPath: "https://home-stage.yunshanmeicai.com/mams/#/index",
    homePath: "https://sso.stage.yunshanmeicai.com/site/index?hometype=1",
    performancePath: "https://home.stage.yunshanmeicai.com/sp-fe-user/",
    myPermission: "https://home.stage.yunshanmeicai.com/permission/#/myPermission",
    kmsPath: "https://kms.stage.yunshanmeicai.com/yunshanPublishHome/index.mc",
    workfacePath: "https://workface.stage.yunshanmeicai.com"

  },
  PRODUCT: {
    loginPath: "https://sso.yunshanmeicai.com/user/logout?system_key=sso",
    oasadminPath: "https://workflow.yunshanmeicai.com",
    tripPath: "https://trip.yunshanmeicai.com/#/mine/trip/list",
    mamsPath: "https://home.yunshanmeicai.com/mams/#/index",
    taskPath: "http://v4.21tb.com/os/html/task/todayTask.index.do?goV5Desk=true",
    subscribePath: "https://webs.yunshanmeicai.com/web/meeting/#/meeting-book",
    todoPath: "https://portal.yunshanmeicai.com/#/todo/list",
    retrievePath: "https://sso.yunshanmeicai.com/user/retrieve",
    helpPath: "https://help.yunshanmeicai.com",
    helpCreatePath: "https://help.yunshanmeicai.com/#/workticket/create?businessId=37",
    mamsPath: "https://home.yunshanmeicai.com/mams/#/index",
    homePath: "https://sso.yunshanmeicai.com/site/index?hometype=1",
    performancePath: "https://home.yunshanmeicai.com/sp-fe-user/",
    myPermission: "https://home.yunshanmeicai.com/permission/#/myPermission",
    managerView: "https://home.yunshanmeicai.com/manager-view/",
    kmsPath: "https://kms.yunshanmeicai.com/yunshanPublishHome/index.mc",
    workfacePath: "https://workface.yunshanmeicai.com"

  }
};

export default urlPath[bootenv];
